// Dark-mode overrides for the HMI CSS variables. Templates that opt into the
// `--hmi-*` variable convention (see bundled blast furnace) adapt automatically;
// templates that hardcode colors are unaffected.
export const HMI_DARK_VARS = {
  '--hmi-label': '#e2e8f0',
  '--hmi-label-sm': '#94a3b8',
  '--hmi-stroke': '#94a3b8',
  '--hmi-stroke-soft': '#64748b',
  '--hmi-ground': '#1e293b',
  '--hmi-steel-a': '#475569',
  '--hmi-steel-b': '#64748b',
  '--hmi-steel-c': '#334155',
};

/** Applies (or clears) the dark HMI CSS variables on an inlined <svg> element. */
export function applyHmiTheme(svgEl, isDark) {
  if (!svgEl) return;
  for (const [k, v] of Object.entries(HMI_DARK_VARS)) {
    if (isDark) svgEl.style.setProperty(k, v);
    else svgEl.style.removeProperty(k);
  }
}
